import {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {updateCartData} from "@/app/slices/CartSlice";
import styles from '@/app/styles/components/pages/cart/sender-form.module.scss'
import {FormattedMessage} from "react-intl";

const SenderForm = () => {

    const [data, setData] = useState({
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        city: '',
        address_1: '',
        postcode: '',
        note: ''
    })
    const [errors, setErrors] = useState({})

    const dispatch = useDispatch()
    const cartData = useSelector((state) => state.cart.data)

    useEffect(() => {
        dispatch(updateCartData({
            senderData: data
        }))
    }, [data])

    useEffect(() => {
        if(cartData && cartData.senderData) {
            setData(cartData.senderData)
        }

    }, [])

    const handleChangeData = (name, value) => {
        setData({
            ...data,
            [name]: value
        })
    }

    const handleCopyDeliveryData = () => {
        setData(cartData.deliveryData)
    }

    const handleSubmit = () => {

    }

    return <div className={styles.senderFormContainer}>
        <h3><FormattedMessage id={'components.pages.cart.senderForm.senderAddress'}/>
            (<span onClick={handleCopyDeliveryData}><FormattedMessage id={'components.pages.cart.senderForm.copyDeliveryData'}/></span>)</h3>
        <form onSubmit={handleSubmit}>
            <div className={styles.inputContainer}>
                <FormattedMessage id={'components.pages.cart.senderForm.firstName'}>
                    {
                        (message) =>
                            <input
                                name={'first_name'}
                                type="text"
                                value={data.first_name}
                                placeholder={message}
                                autoComplete="off"
                                onChange={(e) => handleChangeData('first_name', e.target.value)}
                            />
                    }
                </FormattedMessage>
                {errors?.first_name && <div className={styles.errorMessage}>{errors?.first_name}</div>}
            </div>
            <div className={styles.inputContainer}>
                <FormattedMessage id={'components.pages.cart.senderForm.lastName'}>
                    {
                        (message) =>
                            <input
                                name={'last_name'}
                                type="text"
                                value={data.last_name}
                                placeholder={message}
                                autoComplete="off"
                                onChange={(e) => handleChangeData('last_name', e.target.value)}
                            />
                    }
                </FormattedMessage>
                {errors?.last_name && <div className={styles.errorMessage}>{errors?.last_name}</div>}
            </div>
            <div className={styles.inputContainer}>
                <FormattedMessage id={'components.pages.cart.senderForm.email'}>
                    {
                        (message) =>
                            <input
                                name={'email'}
                                type="text"
                                value={data.email}
                                placeholder={message}
                                autoComplete="off"
                                onChange={(e) => handleChangeData('email', e.target.value)}
                            />
                    }
                </FormattedMessage>
                {errors?.email && <div className={styles.errorMessage}>{errors?.email}</div>}
            </div>
            <div className={styles.inputContainer}>
                <FormattedMessage id={'components.pages.cart.senderForm.phone'}>
                    {
                        (message) =>
                            <input
                                name={'phone'}
                                type="text"
                                value={data.phone}
                                placeholder={message}
                                autoComplete="off"
                                onChange={(e) => handleChangeData('phone', e.target.value)}
                            />
                    }
                </FormattedMessage>
                {errors?.phone && <div className={styles.errorMessage}>{errors?.phone}</div>}
            </div>
            <div className={styles.inputContainer}>
                <FormattedMessage id={'components.pages.cart.senderForm.address'}>
                    {
                        (message) =>
                            <input
                                name={'address_1'}
                                type="text"
                                value={data.address_1}
                                placeholder={message}
                                autoComplete="off"
                                onChange={(e) => handleChangeData('address_1', e.target.value)}
                            />
                    }
                </FormattedMessage>
                {errors?.address_1 && <div className={styles.errorMessage}>{errors?.address_1}</div>}
            </div>
            <div className={styles.inputContainer}>
                <FormattedMessage id={'components.pages.cart.senderForm.city'}>
                    {
                        (message) =>
                            <input
                                name={'city'}
                                type="text"
                                value={data.city}
                                placeholder={message}
                                autoComplete="off"
                                onChange={(e) => handleChangeData('city', e.target.value)}
                            />
                    }
                </FormattedMessage>
                {errors?.city && <div className={styles.errorMessage}>{errors?.city}</div>}
            </div>
            <div className={styles.inputContainer}>
                <FormattedMessage id={'components.pages.cart.senderForm.zipCode'}>
                    {
                        (message) =>
                            <input
                                name={'postcode'}
                                type="text"
                                value={data.postcode}
                                placeholder={message}
                                autoComplete="off"
                                onChange={(e) => handleChangeData('postcode', e.target.value)}
                            />
                    }
                </FormattedMessage>
                {errors?.postcode && <div className={styles.errorMessage}>{errors?.postcode}</div>}
            </div>
        </form>
    </div>
}

export default SenderForm